import React, { useState, useEffect } from 'react';
import NavigationBar from './../NavigationBar';
import { useFeatures } from '../../contexts/FeaturesContext';

const LoginPage = (props) => {
  const [userPermission, setUserPermission] = useState(true);
  const [loginFailure, setLoginFailure] = useState(false);
  const { user, isUserLoading, clearUser } = useFeatures();

  useEffect(() => {
    // Check if user is already logged in and redirect to home
    if (!isUserLoading && user && props.history) {
      props.history.push('/');
    }
  }, [user, isUserLoading, props.history]);

  useEffect(() => {
    if (location.href.indexOf('permissionDenied') !== -1) {
      setUserPermission(false);
    } else if (location.href.indexOf('loginError') !== -1) {
      setLoginFailure(true);
    }
  }, []);
  let googleButtonUrl = '/api/google/oauth';
  if (props.location.search !== undefined) {
    googleButtonUrl += props.location.search;
  }

  return (
    <>
      <NavigationBar loggedStatus={false} clearUser={clearUser} />
      <>
        <div className="row full-page center">
          <div>
            {!userPermission &&
              <div className="alert alert-danger">
                <a href="#" className="close" data-dismiss="alert" aria-label="close">&times;</a>
                <strong>Sorry! </strong>
                You need Admins Permission to Sign In
              </div>
            }
            {loginFailure &&
              <div className="alert alert-danger">
                <a href="#" className="close" data-dismiss="alert" aria-label="close">&times;</a>
                <strong>Sorry! </strong>
                Your Google login failed
              </div>}
          </div>
          <div className="googleLoginButton">
            <a href={googleButtonUrl} className="btn btn-primary btn-google-sign-up flex-row">
              <i className="fa fa-google-plus" />
              <span>Sign In using Google</span>
            </a>
          </div>
        </div>
      </>
    </>
  );
};

export default LoginPage;
